<template>
  <div class="our-vision-area bg-gray3">
    <div class="container mw-1356">
      <div class="row g-0 align-content-end">
        <div class="col-xl-6">
          <div class="our-vision-img">
            <img src="@/assets/images/our-vision.jpg" alt="our-vision" />
          </div>
        </div>

        <div class="col-xl-6">
          <div class="our-mision-content vision ptb-100">
            <span class="top-title">رؤيتنا</span>
            <h2>رؤيتنا المستقبلية</h2>
            <ul class="ps-0 mb-0 list-unstyled mission-list">
              <li class="d-flex">
                <i class="ti ti-circle-check"></i>
                <div class="">
                  <span>الريادة العالمية في البث الرقمي:</span>
                  <p>
                    أن نصبح الخيار الأول عالمياً في تقديم خدمات IPTV فائقة الجودة، مع وضع معايير جديدة للابتكار في عالم الترفيه المنزلي.
                  </p>
                </div>
              </li>
              <li class="d-flex">
                <i class="ti ti-circle-check"></i>
                <div class="">
                  <span>تعزيز نمط الحياة الرقمي:</span>
                  <p>
                    تمكين عملائنا من الوصول إلى محتواهم المفضل في أي وقت ومن أي مكان، بأسلوب حياة رقمي يعتمد على السهولة والجودة العالية.
                  </p>
                </div>
              </li>
              <li class="d-flex">
                <i class="ti ti-circle-check"></i>
                <div class="">
                  <span>التميز في الأداء التقني:</span>
                  <p>
                    الاستمرار في تطوير تقنيات بث متطورة تضمن لمشتركينا استقراراً تاماً وتجربة مشاهدة غامرة تسبق توقعاتهم.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  // اسم متعدد الكلمات لتجنب خطأ ESLint
  name: "CompanyVision",
});
</script>